import { PortfolioSourcesEventsService } from '@festina/unitlink-general-types/unitlink/services/PortfolioSourcesEventsService'
import { PortfoliosSwitchSubPortfolioGroupsService } from '@festina/unitlink-general-types/unitlink/services/PortfoliosSwitchSubPortfolioGroupsService'
import { useCreateCommandActions } from '@festina-life/authentication'

import type { PortfolioActionProps } from '../types'

class PortfoliosSwitchSubPortfolioGroupsServiceOverwrite extends PortfoliosSwitchSubPortfolioGroupsService {
  static portfolioSourcesServiceDeleteCancelEvent =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent

  static portfolioSourcesServiceDeleteCancelEvent_roles =
    PortfolioSourcesEventsService.portfolioSourcesServiceDeleteCancelEvent_roles

  static portfolioSourcesServicePutEvents = ({
    requestBody: commandData,
    ...rest
  }: Parameters<
    typeof PortfoliosSwitchSubPortfolioGroupsService.portfolioSwitchSubPortfolioGroupServicePostEntity
  >[0] & { eventId: string }) =>
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents({
      ...rest,
      requestBody: {
        _type: 'UpdateSwitchSubPortfolioGroupCommand',
        commandData,
      },
    })

  static portfolioSourcesServicePutEvents_roles =
    PortfolioSourcesEventsService.portfolioSourcesServicePutEvents_roles
}

export const useSwitchSubPortfolioGroupActions = (
  serviceArguments: PortfolioActionProps,
) =>
  useCreateCommandActions({
    component: 'unitLink',
    service: PortfoliosSwitchSubPortfolioGroupsServiceOverwrite,
    methods: {
      create: 'portfolioSwitchSubPortfolioGroupServicePostEntity',
      cancel: 'portfolioSourcesServiceDeleteCancelEvent',
      update: 'portfolioSourcesServicePutEvents',
    },
    serviceArguments: {
      eventId: serviceArguments.commandId ?? '', // will be there when needed
      ownerId: serviceArguments.ownerId,
    },
  })
